<template>
  <b-card
    :title="item.fullName||'...'"
  >
    <b-tabs>
      <b-tab :title="$t('General')">
        <form-user
          :key="'userform'"
          ref="user_form"
          v-model="item"
          :show-file-upload="false"
          @submit="success"
          @error="error"
        />
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="d-inline-block mr-1"
          @click="generalTabSubmit"
        >
          {{ $t('Save') }}
        </b-button>
      </b-tab>
      <b-tab :title="$t('Projects')">
        <table-user-projects :user-id="Number($route.params.id)" />
      </b-tab>
      <!-- HotAlert config tab -->
      <b-tab
        :title="$t('HotAlert Config')"
      >
        <table-user-hot-alert-configs :user-id="Number($route.params.id)" />
      </b-tab>
      <!-- Approval config tab -->
      <b-tab
        :title="$t('Approval Config')"
      >
        <table-user-approval-configs :user-id="Number($route.params.id)" />
      </b-tab>

    </b-tabs>

  </b-card>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BButton, BCard, BTabs, BTab,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import FormUser from '@/layouts/components/forms/FormUser.vue'
import TableUserProjects from '@/layouts/components/TableUserProjects.vue'
import TableUserHotAlertConfigs from '@/layouts/components/TableUserHotAlertConfigs.vue'
import TableUserApprovalConfigs from '@/layouts/components/TableUserApprovalConfigs.vue'

export default {
  components: {
    BCard,
    BButton,
    BTabs,
    BTab,
    FormUser,
    TableUserProjects,
    TableUserHotAlertConfigs,
    TableUserApprovalConfigs,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      item: {
        fullName: null,
        email: null,
        role: null,
      },
    }
  },
  created() {
    if (this.$route.params.id && this.$route.params.id > 0) {
      this.initDetail()
    }
  },
  methods: {
    error(msg) {
      this.inProgress = false
      this.$swal({
        icon: 'error',
        title: 'Error!',
        text: msg.indexOf('email_unique') > -1 ? this.$t('Email exists!') : msg,
        customClass: {
          confirmButton: 'btn btn-danger',
        },
      })
    },
    success() {
      this.$swal({
        icon: 'success',
        title: 'Saved!',
        text: 'Saved successfuly.',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    generalTabSubmit() {
      this.$refs.user_form.validationForm()
    },
    initDetail() {
      useJwt.axiosIns.get(`user/${this.$route.params.id}`)
        .then(response => {
          if (response.data) {
            this.item = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>
